import { Form } from "antd";
import { useReducer, useEffect, useMemo } from "react";
import { MessageAnt } from "../../../../redux/slices/ui/uiAction";
import { Endpoints } from "../../../../config/type_endpoints";
import { columnsPlatforms } from "../helpers/columnsPlatforms";
import { replaceIdURL } from "../../../../helpers/replaceId";
import { MessageType } from "../../../../types/messageType";
import { apiaxios } from "../../../../config/axios";

const initialState = {
    isLoading: false,
    searchValue: "",
    tableData: [],
    tablePagination: [],
    activeModal: false,
    typeModal: 0,
    dataForm: {},
    selectedPlatform: "",
    loadingButton: false,
};

function reducer(state, action) {
    switch (action.type) {
        case "SET_LOADING":
            return { ...state, isLoading: action.payload };
        case "SET_SEARCH_VALUE":
            return { ...state, searchValue: action.payload };
        case "SET_TABLE_DATA":
            return { ...state, tableData: action.payload };
        case "SET_TABLE_PAGINATION":
            return { ...state, tablePagination: action.payload };
        case "SET_ACTIVE_MODAL":
            return { ...state, activeModal: action.payload };
        case "SET_TYPE_MODAL":
            return { ...state, typeModal: action.payload };
        case "SET_DATA_FORM":
            return { ...state, dataForm: action.payload };
        case "SET_SELECTED_PLATFORM":
            return { ...state, selectedPlatform: action.payload };
        case "SET_LOADING_BUTTON":
            return { ...state, loadingButton: action.payload };
        default:
            throw new Error(`Unknown action type: ${action.type}`);
    }
}



export const usePagePlatformsData = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [form] = Form.useForm();

    const setData = async () => {
        try {
            dispatch({ type: "SET_LOADING", payload: true });
            const { data: platformApi } = await apiaxios.get(`${Endpoints.platform.getall_create}?getInactives=true`);
            const newPlatforms = platformApi.payload.map((area) => ({
                key: area._id,
                ...area,
            }));
            dispatch({ type: "SET_TABLE_DATA", payload: newPlatforms });
            dispatch({ type: "SET_TABLE_PAGINATION", payload: newPlatforms.length });
        } catch (error) {
            console.error(error);
            MessageAnt(MessageType.error, `Error de servidor`);
        } finally {
            dispatch({ type: "SET_LOADING", payload: false });
        }
    };



    const deleteAction = async (id) => {
        try {
            const url = replaceIdURL(Endpoints.platform.put_delete, "id", id);
            const { data: platformApi } = await apiaxios.delete(`${url}`);
            setData();
            if (platformApi.status > 0) {
                console.log(platformApi);
                MessageAnt(MessageType.error, `Error al editar areas`);
            } else {
                MessageAnt(MessageType.success, `Se elimino area`);
            }
        } catch (error) {
            console.log(error);
            MessageAnt(MessageType.error, `Error de servidor`);
        }
    };

    const editAction = (form = null) => {
        if (form) {
            dispatch({ type: "SET_DATA_FORM", payload: { ...form } });
            dispatch({ type: "SET_SELECTED_PLATFORM", payload: form.key });
        }
        dispatch({ type: "SET_TYPE_MODAL", payload: 1 });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: true });
    };

    const createPlatforms = async (form) => {
        try {
            const { data: platformApi } = await apiaxios.post(`${Endpoints.platform.getall_create}`, form);
            setData();
            dispatch({ type: "SET_TYPE_MODAL", payload: 1 });
            if (platformApi.status > 0) {
                console.log(platformApi);
                MessageAnt(MessageType.error, `Error al crear areas`);
            } else {
                MessageAnt(MessageType.success, `Se creo area`);
            }
        } catch (error) {
            console.log(error);
            MessageAnt(MessageType.error, `Error de servidor`);
        } finally {
            dispatch({ type: "SET_LOADING_BUTTON", payload: false });
            dispatch({ type: "SET_ACTIVE_MODAL", payload: false });
        }
    };

    const editPlatforms = async (form) => {
        try {
            const url = replaceIdURL(Endpoints.platform.put_delete, "id", state.selectedPlatform);
            const { data: platformApi } = await apiaxios.put(`${url}`, form);
            setData();
            if (platformApi.status > 0) {
                MessageAnt(MessageType.error, `Error al editar areas`);
            } else {
                MessageAnt(MessageType.success, `Se edito area ${form.name}`);
            }
        } catch (error) {
            console.log(error);
            MessageAnt(MessageType.error, `Error de servidor`);
        } finally {
            dispatch({ type: "SET_LOADING_BUTTON", payload: false });
            dispatch({ type: "SET_ACTIVE_MODAL", payload: false });
            dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
        }
    };

    const onFinish = (values) => {
        dispatch({ type: "SET_LOADING_BUTTON", payload: true });
        const structureForm = { ...values };
        if (state.typeModal === 0) {
            createPlatforms(structureForm);
        } else {
            editPlatforms(structureForm);
        }
    };

    const handleOpenModalCreate = () => {
        dispatch({ type: "SET_DATA_FORM", payload: { isActive: true, name: "" } });
        dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: true });
    };

    const handleOnCancel = () => {
        dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: false });
    };

    const handleChange = (e) => {
        dispatch({ type: "SET_SEARCH_VALUE", payload: e.target.value });
    };

    const { columns, props } = columnsPlatforms(editAction, deleteAction, state.tablePagination);
    const { pagination, ...tableProps } = props;

    const tableFilterDataPlatforms = useMemo(() => {
        return state.tableData.filter((item) => {
            return item.name.toLocaleLowerCase().includes(state.searchValue.toLocaleLowerCase());
        });
    }, [state.tableData, state.searchValue]);

    useEffect(() => {
        form.setFieldsValue({
            isActive: state.dataForm.isActive,
            name: state.dataForm.name,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.dataForm]);

    useEffect(() => {
        setData();
    }, []);

    return {
        searchValue: state.searchValue,
        activeModal: state.activeModal,
        typeModal: state.typeModal,
        loadingButton: state.loadingButton,
        form,
        isLoading: state.isLoading,
        handleOpenModalCreate,
        handleOnCancel,
        onFinish,
        tableFilterDataPlatforms,
        handleChange,
        columns,
        tableProps,
        pagination,
    };
};
